X
<template>
  <smart-image
    v-if="init?.companyImage"
    :imageURL="init.companyImage"
    class="my-4 style-img"
  />
</template>

<script>
import { mapGetters } from "vuex";
import SmartImage from "./SmartImage.vue";

export default {
  name: "CompanyLogo",
  components: { SmartImage },
  computed: {
    ...mapGetters(["init"]),
  },
};
</script>

<style lang="scss" scoped>
.style-img {
  max-width: 60%;
  max-height: 200px;
  min-height: 150px;
  object-fit: contain;
}
</style>
